/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 * Filename and corresponding read url for a sample in a tag
 * @export
 * @interface FilenameAndReadUrl
 *
 */
// create custom validators for the regexes
export interface FilenameAndReadUrl {
    /**
     *
     * #type string
     * #memberof FilenameAndReadUrl
        
        
         */
    fileName: string;
    /**
     * A URL which allows anyone in possession of said URL to access the resource
     * #type string
     * #memberof FilenameAndReadUrl
        
        
         */
    readUrl: string;
}
/**
 * Check if a given object implements the FilenameAndReadUrl interface.
 */
export function instanceOfFilenameAndReadUrl(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "readUrl" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const FilenameAndReadUrlTypiaAssertEquals = (input: any) => {
    return ((input: any): FilenameAndReadUrl => {
        const __is = (input: any, _exceptionable: boolean = true): input is FilenameAndReadUrl => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.fileName && "string" === typeof input.readUrl && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["fileName", "readUrl"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is FilenameAndReadUrl => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.fileName || $guard(_exceptionable, {
                    path: _path + ".fileName",
                    expected: "string",
                    value: input.fileName
                })) && ("string" === typeof input.readUrl || $guard(_exceptionable, {
                    path: _path + ".readUrl",
                    expected: "string",
                    value: input.readUrl
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["fileName", "readUrl"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "FilenameAndReadUrl",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "FilenameAndReadUrl",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const FilenameAndReadUrlTypiaAssertStringify = (input: FilenameAndReadUrl): string => {
    return ((input: any): string => { const assert = (input: any): FilenameAndReadUrl => {
        const __is = (input: any): input is FilenameAndReadUrl => {
            return "object" === typeof input && null !== input && ("string" === typeof (input as any).fileName && "string" === typeof (input as any).readUrl);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is FilenameAndReadUrl => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.fileName || $guard(_exceptionable, {
                    path: _path + ".fileName",
                    expected: "string",
                    value: input.fileName
                })) && ("string" === typeof input.readUrl || $guard(_exceptionable, {
                    path: _path + ".readUrl",
                    expected: "string",
                    value: input.readUrl
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "FilenameAndReadUrl",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "FilenameAndReadUrl",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: FilenameAndReadUrl): string => {
        const $string = (typia.createAssertStringify as any).string;
        return `{"fileName":${$string((input as any).fileName)},"readUrl":${$string((input as any).readUrl)}}`;
    }; return stringify(assert(input)); })(input);
};
export const FilenameAndReadUrlValidatorShape = {
    'fileName': yup.string().defined(),
    'readUrl': yup.string().defined(),
};
export const FilenameAndReadUrlValidator = yup.object().shape(FilenameAndReadUrlValidatorShape);
export const FilenameAndReadUrlStringifyShapeProperties: ObjectSchema['properties'] = {
    'fileName': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'readUrl': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
};
export const FilenameAndReadUrlStringifyShape: ObjectSchema = {
    title: 'FilenameAndReadUrl Stringifier',
    type: 'object',
    properties: {
        ...FilenameAndReadUrlStringifyShapeProperties
    },
    required: [
        'fileName',
        'readUrl',
    ],
};
export const FilenameAndReadUrlStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(FilenameAndReadUrlStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const FilenameAndReadUrlStringify: (data: FilenameAndReadUrl) => string = FilenameAndReadUrlStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function FilenameAndReadUrlFromJSON(json: any): FilenameAndReadUrl {
    return FilenameAndReadUrlFromJSONTyped(json, false);
}
export function FilenameAndReadUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilenameAndReadUrl {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'fileName': json['fileName'],
        'readUrl': json['readUrl'],
    };
}
export function FilenameAndReadUrlToJSON(value?: FilenameAndReadUrl | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fileName': value.fileName,
        'readUrl': value.readUrl,
    };
}
